export const buildDestinatario = function (item, destinatario) {
  // TODO: Implementare la scelta dei vari numeri a cui inviare un messaggio
  let to = []
  let nome = ''
  let numero = ''
  numero = _.get(item, 'cellulare') || ''
  nome = _.get(item, 'tipo.descrizione') || numero
  if (numero) to.push({ nome, numero })
  return to

  /*   let to = []
    const tdd = destinatario.split(',')
    for (let td of tdd) {
      let nome = ''
      let email = ''
      let sede = null
      switch(td) {
        case 'fatture':
          email = _.get(item, 'fatturazione.emailInvio') || ''
          nome = _.get(item, 'ragioneSociale') || email
          if (email) to.push({ nome, email })
          break
        case 'pec':
          email = _.get(item, 'fatturazione.pec') || ''
          nome = _.get(item, 'ragioneSociale') || email
          if (email) to.push({ nome, email })
          break
        case 'sede':
          sede = item.recapiti ? item.recapiti.find(x => x.tipo && x.tipo.codice === 'principale') : null
          if (sede) {
            email = sede.email || ''
            nome = email  // TODO: Prevedere una Descrizione del recapito
            if (email) to.push({ nome, email })
          }
          break
        case 'recapiti':
          break
        case 'primoCompilato':
          email = _.get(item, 'fatturazione.emailInvio') || ''
          nome = _.get(item, 'ragioneSociale') || email
          if (!email) {
            email = _.get(item, 'fatturazione.pec') || ''
            nome = _.get(item, 'ragioneSociale') || email
          }
          if (!email) {
            sede = item.recapiti ? item.recapiti.find(x => x.tipo && x.tipo.codice === 'principale') : null
            if (sede) {
              email = sede.email || ''
              nome = email 
            }
          }
          if (email) to.push({ nome, email })
          break
        case 'tutti':
          email = _.get(item, 'fatturazione.emailInvio') || ''
          nome = _.get(item, 'ragioneSociale') || email
          if (email) to.push({ nome, email })
          email = _.get(item, 'fatturazione.pec') || ''
          nome = _.get(item, 'ragioneSociale') || email
          if (email) to.push({ nome, email })
          sede = item.recapiti ? item.recapiti.find(x => x.tipo && x.tipo.codice === 'principale') : null
          if (sede) {
            email = sede.email || ''
            nome = email
            if (email) to.push({ nome, email })
          }             
          break
        default:
          break
      }   
    }
    return to */
}


export const buildDestinatarioSms = function (item, destinatario) {
  // TODO: Implementare la scelta dei vari numeri a cui inviare un messaggio
  let to = []
  let nome = ''
  let numero = ''
  numero = _.get(item, 'cellulare') || ''
  return numero

  // TODO: Gestire destinatari mutipli e campi per sostituzioni su body (solo openapi)

  /*   nome = _.get(item, 'tipo.descrizione') || numero
    if (numero) to.push({ nome, numero })
    return to */
}
